import React, { Component, PropTypes } from "react"; //eslint-disable-line
import classnames from "classnames";
import style from "./style.css";
import Tick from "../../../assets/svg/tick.svg";

/**
 * TVG Checkbox Component
 */
class Checkbox extends Component {
  static defaultProps = {
    qaLabel: ""
  };

  constructor(props) {
    super(props);
  }

  onChange;

  onChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(e.target.checked);
    }
  };

  props;

  render() {
    const checkboxClass = classnames({
      [style.checkbox]: true,
      [style.checkbox__mobile]: this.props.mobile
    });

    return (
      <div className={checkboxClass}>
        <input
          type="checkbox"
          id={this.props.id}
          checked={this.props.checked}
          onChange={(e) => this.onChange(e)}
          data-qa-label={this.props.qaLabel.concat("Field")}
        />
        <label
          htmlFor={this.props.id}
          data-qa-label={this.props.qaLabel.concat("Label")}
        >
          <Tick width="16px" height="16px" fill="#5c9de0" />
          {this.props.children}
        </label>
      </div>
    );
  }
}

export default Checkbox;
